import React, { useMemo, useState, useCallback, memo } from "react";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import PriceInfo from "../PriceInfo";

import pigIcon from "../../assents/img/pig.svg";
import infoIcon from "../../assents/img/info.svg";
import clockIcon from "../../assents/img/clock.svg";

const Wrapper = styled(Box)(() => ({
  display: "flex",
  position: "absolute",
  top: "10px",
  left: "10px",
  boxSizing: "border-box",
}));

const StopInfoTime = styled(Box)(() => ({
  width: "96px",
  height: "34px",
  padding: "9.5px 8px",
  background: "rgba(0, 0, 0, 0.5)",
  borderRadius: "5px 0px 0px 5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxSizing: "border-box",
}));

const StopInfoText = styled(Typography)(() => ({
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "12px",
  color: "#ffffff",
  whiteSpace: "nowrap",
}));

const StopInfoValue = styled(Box)(() => ({
  width: "96px",
  height: "34px",
  padding: "9.5px 11.5px",
  background: "rgba(0, 0, 0, 0.5)",
  borderRadius: "0px 5px 5px 0px",
  marginLeft: "1px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxSizing: "border-box",
}));

const StopInfoBlock = memo(
  ({
    priceMinute,
    total,
    tourDefaultPrice,
    duration,
    priceAdult,
    priceChild,
    priceInfant,
  }) => {
    const [showPriceInfo, setShowPriceInfo] = useState(false);
    
    
    const durationCost = useMemo(() => {
      return priceMinute * duration
    }, [])
    
    const getTotalPrice = useMemo(() => {
      const price =
        Number(Number(priceAdult).toFixed(0)) * total.adults +
        Number(Number(priceChild).toFixed(0)) * total.children +
        Number(Number(priceInfant).toFixed(0)) * total.infants + (priceMinute * duration)
      return price;
    }, [tourDefaultPrice, priceAdult, priceChild, priceInfant, total, priceMinute, duration]);
    
    const handleMouseOver = useCallback(() => setShowPriceInfo(true), []);

    const handleMouseLeave = useCallback(() => setShowPriceInfo(false), []);

    return (
      <Wrapper>
        <StopInfoTime>
          <img src={clockIcon} alt="clock icon" />
          <StopInfoText>{duration} minutes</StopInfoText>
        </StopInfoTime>
        <StopInfoValue>
          <img src={pigIcon} alt="pig icon" />
          <StopInfoText>€{Math.ceil(getTotalPrice)}</StopInfoText>
          <img
            src={infoIcon}
            alt="info icon"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseLeave}
          />
          {showPriceInfo && (
            <PriceInfo
              total={total}
              priceAdult={priceAdult}
              priceChild={priceChild}
              priceInfant={priceInfant}
              totalPrice={getTotalPrice}
              durationCost={durationCost}
            />
          )}
        </StopInfoValue>
      </Wrapper>
    );
  }
);

export default StopInfoBlock;
